import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { breadcrumbListSchema, toJsonLd, withHome, type Crumb } from '../lib/breadcrumbs';

interface BreadcrumbsProps {
  // The pages after Home, ending with the current page.
  trail: Crumb[];
  className?: string;
}

// The visible trail and its BreadcrumbList JSON-LD are built from the same
// list, so the markup can never describe a different path than the page shows.
export default function Breadcrumbs({ trail, className = 'mb-12' }: BreadcrumbsProps) {
  const crumbs = withHome(trail);
  const lastIndex = crumbs.length - 1;

  return (
    <>
      <nav aria-label="Breadcrumb" className={className}>
        <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 list-none p-0 m-0 text-sm font-medium tracking-wide">
          {crumbs.map((crumb, index) => (
            <li key={crumb.path} className="flex items-center gap-2">
              {index > 0 && <ChevronRight aria-hidden="true" className="w-3.5 h-3.5 text-white/30 shrink-0" />}
              {index === lastIndex ? (
                <span aria-current="page" className="text-white/80">
                  {crumb.name}
                </span>
              ) : (
                <Link to={crumb.path} className="text-white/55 hover:text-white transition-colors">
                  {crumb.name}
                </Link>
              )}
            </li>
          ))}
        </ol>
      </nav>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: toJsonLd(breadcrumbListSchema(crumbs)) }} />
    </>
  );
}
